import React from 'react';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { RMSvgIconNames } from 'components/customComponents/CommonComponents/RMSvgIcon';
import { CustomCheckBox } from 'components/input';

export interface Props {
  isChecked: boolean;
  isVisible: boolean;
  onCheckboxChange: (columnId: number | string) => void;
  onVisibilityChange?: (columnId: number | string) => void;
  columnId: number | string;
  columnTitle: string;
  containerClass?: string;
  labelClass?: string;
  showCheckboxBeforeTitle?: boolean;
}

const iconCLasses = {
  EyeOpen: 'bg-black',
  EyeClosed: '',
};

const CheckboxBeforeLabel = (props: Props) => {
  const {
    isChecked,
    isVisible,
    onCheckboxChange,
    onVisibilityChange,
    columnId,
    columnTitle,
    containerClass = '',
    labelClass = '',
  } = props;

  const visibilityIcon: RMSvgIconNames = isVisible ? 'EyeOpen' : 'EyeClosed';

  return (
    <div
      id="checkboxbeforelabel-main-container"
      className={`flex items-center ${containerClass}`}
    >
      <div
        id="checkboxbeforelabel-checkbox-wrapper"
        className="flex gap-2 justify-end align-center"
      >
        <CustomCheckBox
          type="checkbox"
          checked={isChecked}
          onChange={() => onCheckboxChange(columnId)}
        />
        {onVisibilityChange && (
          <RMCustomButton
            onClick={() => onVisibilityChange(columnId)}
            iconProps={{ name: visibilityIcon, fill: 'black', width: 18, height: 18 }}
            iconClass={`border rounded-sm ${iconCLasses[visibilityIcon]}`}
          />
        )}
      </div>
      <div id="checkboxbeforelabel-label" className="flex w-10/12">
        <label id="checkboxbeforelabel-label-text" className={`${labelClass} truncate`}>
          {columnTitle}
        </label>
      </div>
    </div>
  );
};

export default CheckboxBeforeLabel;
